<div>
	<app-breadcrumbs></app-breadcrumbs>
</div>
<div class="iframe-container">
	<app-content-app-iframe></app-content-app-iframe>
</div>
